import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
import { LenticMark } from '../LenticMark';
import { ForkDiagram } from './ForkDiagram';
import { EYEBROW } from './Band';
import { heroCommitments } from '../../data/site';
export function Hero() {
  return <section id="top" className="relative w-full overflow-hidden bg-bone" data-id="element-185" data-mp="9n16i8qjtsq4">
      <div className="pointer-events-none absolute -right-40 -top-32 opacity-[0.12] lg:-right-20" data-id="element-186" data-mp="9oucdltc88x2">
        <LenticMark size={620} title={null} data-id="element-187" data-mp="12b6sszx93ps2" />
      </div>

      <div className="relative mx-auto grid w-full max-w-6xl gap-14 px-6 pb-24 pt-20 lg:grid-cols-[0.85fr_1.15fr] lg:items-center lg:gap-16 lg:px-10 lg:pb-32 lg:pt-28" data-id="element-188" data-mp="12chyx6e659mc">
        <motion.div initial={{
        opacity: 0,
        y: 14
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        ease: [0.22, 1, 0.36, 1]
      }} data-id="element-189" data-mp="sm5ede6ctgg7">
          <p className={`inline-flex items-center rounded-full border border-mist bg-white/60 px-3.5 py-1.5 ${EYEBROW} text-teal`} data-id="element-190" data-mp="1l9rjiqv8ct56">
            Hiring signal for AI-assisted work
          </p>

          <h1 className="mt-5 font-display text-[32px] font-light leading-[1.05] tracking-tight text-ink sm:text-[46px] lg:text-[60px]" data-id="element-191" data-mp="3nj3rnaeau0oi">
            <span className="block" data-id="element-192" data-mp="39r71vd03s2va">Assume the AI.</span>
            <span className="block" data-id="element-193" data-mp="3epqpdhuchmpr">Provide the AI.</span>
            <span className="block whitespace-nowrap font-medium text-teal" data-id="element-194" data-mp="3eo77xnwyd5me">
              Measure what's left.
            </span>
          </h1>

          <p className="mt-7 max-w-[46ch] text-lg leading-relaxed text-graphite sm:text-xl" data-id="element-195" data-mp="34smam32twtiz">
            Take-homes come back perfect and tell you nothing. Lentic gives every candidate an assistant that reasons but can't see the source files, then records how they handle six scenarios — calibrated to the role, and not all of them contain an error.
          </p>

          <div className="mt-10 flex flex-wrap items-center gap-4" data-id="element-196" data-mp="u0b1ovqfae4c">
            <a href="#contact" className="inline-flex items-center gap-2 rounded-full bg-ink px-7 py-4 text-base font-semibold text-bone transition-colors hover:bg-teal" data-id="element-197" data-mp="tzji6ja3o6uf">
              Book a walkthrough
              <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-198" data-mp="niri48o9zpse" />
            </a>
            <a href="#record" className="inline-flex items-center gap-2 rounded-full border border-ink/15 px-7 py-4 text-base font-semibold text-ink transition-colors hover:border-ink/40" data-id="element-199" data-mp="ilhripp5h82z">
              See what's in a decision record
            </a>
          </div>
        </motion.div>

        <ForkDiagram data-id="element-200" data-mp="16bvalqprbwlf" />
      </div>

      <div className="relative border-y border-mist bg-white/50" data-id="element-201" data-mp="16cwo01u8wv6b">
        <div className="mx-auto w-full max-w-6xl px-6 py-12 lg:px-10" data-id="element-202" data-mp="11iixodufxe8i">
          <p className={`${EYEBROW} text-graphite`} data-id="element-203" data-mp="wlity9l2cnkk">Design commitments</p>
          <dl className="mt-7 grid gap-x-10 gap-y-8 sm:grid-cols-2 lg:grid-cols-4" data-id="element-204" data-mp="1u04tokvl668v">
            {heroCommitments.map(item => <div key={item.label} className="border-t border-mist pt-4" data-id="element-205" data-mp="1p8wjhmmfmgun">
                <dt className="font-display text-3xl font-light text-ink" data-id="element-206" data-mp="1p7litvoa9p7r">
                  {item.value}
                </dt>
                <dd className="mt-2 max-w-[30ch] text-base leading-snug text-graphite" data-id="element-207" data-mp="21j4bwn7b9rqn">
                  {item.label}
                </dd>
              </div>)}
          </dl>
          <p className="mt-8 max-w-[68ch] text-sm leading-relaxed text-graphite" data-id="element-208" data-mp="2bhtuyjay1i8h">
            How the system is built, not published performance figures. We
            publish operating metrics once they are measured across live
            cohorts.
          </p>
        </div>
      </div>
    </section>;
}